import { createFileRoute, redirect } from '@tanstack/react-router'
import { SharedPage } from '@/components/pages/SharedPage'
import { FEATURES } from '@/lib/features'

export const Route = createFileRoute('/workspace/shared')({
  beforeLoad: () => {
    // Sharing is unfinished — a pasted URL must not reach it either.
    if (!FEATURES.SHARING) throw redirect({ to: '/workspace' })
  },
  component: SharedPage,
})
